export default function () {
	return {
		parentProductId: window.freeGifts.parent,
		giftProductId: window.freeGifts.gift,
		giftPresent: this.$persist(false).using(sessionStorage),
		getNumberFromString(string) {
			const formated_string = string.match(/\d+/);
			if (formated_string) {
				const nums = Number(formated_string[0]);
				if (nums) {
					return nums;
				}
			} else return '';
		},

		onQuantityInputChange(itemKey) {
			let quantity = this.$el.value;
			let formData = {
				updates: {},
				sections: 'cart-main,header',
			};

			formData.updates[itemKey] = quantity;

			this.updateCart(formData);
		},

		itemIncrease(itemKey, itemQty) {
			let quantity = +itemQty + 1;
			let formData = {
				updates: {},
				sections: 'cart-main,header',
			};

			formData.updates[itemKey] = quantity;

			this.updateCart(formData);
		},

		itemReduce(itemKey, itemQty) {
			let quantity = +itemQty - 1;
			let formData = {
				updates: {},
				sections: 'cart-main,header',
			};

			formData.updates[itemKey] = quantity;

			this.updateCart(formData);
		},

		itemDelete(itemKey) {
			let quantity = 0;
			let formData = {
				updates: {},
				sections: 'cart-main,header',
			};

			formData.updates[itemKey] = quantity;

			this.updateCart(formData);
		},

		updateCart(formData) {
			fetch(window.Shopify.routes.root + 'cart/update.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(formData),
			})
				.then((response) => {
					if (response.ok) {
						this.$dispatch('cart-update');
					}
					return response.json();
				})
				.then((data) => {
					let destination = document.getElementById('cart-main');
					let source = new DOMParser()
						.parseFromString(data?.sections['cart-main'], 'text/html')
						.getElementById('cart-main');
					const destinationCartPopup = document.getElementById('cart-popup');
					const sourceCartPopup = new DOMParser()
						.parseFromString(data?.sections['header'], 'text/html')
						.getElementById('cart-popup');

					if (destination && source) {
						destination.innerHTML = source.innerHTML;
					}
					if (destinationCartPopup && sourceCartPopup) {
						destinationCartPopup.innerHTML = sourceCartPopup.innerHTML;
					}
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		},

		addFreeGift() {
			if (!this.giftProductId && !this.parentProductId) return;
			setTimeout(async () => {
				const parent_present = this.cart.items.find((item) => item.id === this.parentProductId);
				const gift_present = this.cart.items.find((item) => item.id === this.giftProductId);
				if (parent_present && !gift_present) {
					let formData = {
						items: [
							{
								id: this.giftProductId,
								quantity: 1,
							},
						],
						sections: 'cart-main,header',
					};

					const response = await fetch(window.routes.cartAdd + '.js', {
						method: 'POST',
						credentials: 'same-origin',
						headers: {
							'Access-Control-Allow-Origin': 'no-cors',
							'Content-Type': 'application/json',
							'X-Requested-With': 'XMLHttpRequest',
						},
						body: JSON.stringify(formData),
					});

					const data = await response.json();
					if (response.ok) {
						const destinationCartPopup = document.getElementById('cart-popup');
						const sourceCartPopup = new DOMParser()
							.parseFromString(data.sections['header'], 'text/html')
							.getElementById('cart-popup');

						if (destinationCartPopup && sourceCartPopup) {
							destinationCartPopup.innerHTML = sourceCartPopup.innerHTML;
						}

						this.$dispatch('cart-update');
					}
					this.giftPresent = true;
				} else if (!parent_present && gift_present && this.giftPresent) {
					let quantity = 0;
					let formDataT = {
						updates: {},
						sections: 'cart-main,header',
					};
					formDataT.updates[this.giftProductId] = quantity;
					const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
						method: 'POST',
						credentials: 'same-origin',
						headers: {
							'Access-Control-Allow-Origin': 'no-cors',
							'Content-Type': 'application/json',
							'X-Requested-With': 'XMLHttpRequest',
						},
						body: JSON.stringify(formDataT),
					});

					const data = await response.json();
					if (response.ok) {
						const destinationCartPopup = document.getElementById('cart-popup');
						const sourceCartPopup = new DOMParser()
							.parseFromString(data.sections['header'], 'text/html')
							.getElementById('cart-popup');

						if (destinationCartPopup && sourceCartPopup) {
							destinationCartPopup.innerHTML = sourceCartPopup.innerHTML;
						}

						this.$dispatch('cart-update');
					}
					this.giftPresent = false;
					window.location.reload();
				} else if (parent_present && gift_present) {
					this.giftPresent = true;
				}
			}, 1250);
		},

		init() {
			// this.$watch('cart', ()=> {
			// 	this.addFreeGift();
			// })
		},
	};
}
